import { useEffect, useState } from "react";
import { toast } from "sonner";

export default function UsersPanel({ call }) {
  const [data, setData] = useState({ roles: [], users: [] });

  useEffect(() => { call("get", "/users").then(setData).catch(() => {}); }, [call]);

  const change = async (user_id, role) => {
    try {
      await call("patch", `/users/${user_id}/role`, { role });
      setData((d) => ({ ...d, users: d.users.map((u) => (u.user_id === user_id ? { ...u, role } : u)) }));
      toast.success("Role updated");
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not update role"); }
  };

  return (
    <section className="mt-20" data-testid="users-panel">
      <h2 className="font-heading text-lg text-gold-soft tracking-widest">PEOPLE WITH ACCESS</h2>
      <div className="space-y-3 mt-5">
        {data.users.map((u) => (
          <div key={u.user_id} className="glass rounded-xl px-5 py-3 flex justify-between items-center gap-4" data-testid={`user-row-${u.user_id}`}>
            <span className="text-sm text-[#f7f1e1]/80 truncate">{u.email || u.user_id}</span>
            <select value={u.role} onChange={(e) => change(u.user_id, e.target.value)} className="field !w-32 shrink-0 py-2" data-testid={`user-role-select-${u.user_id}`}>
              {data.roles.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
        ))}
      </div>
    </section>
  );
}
